/**
 * @generated SignedSource<<bfbb442b703ded208fddf12b64889c64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventPanelListFragment_event$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly happenedAt: any | null | undefined;
      readonly id: string;
      readonly type: {
        readonly id: string;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"EventCardFragment">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "EventPanelListFragment_event";
};
export type EventPanelListFragment_event$key = {
  readonly " $data"?: EventPanelListFragment_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventPanelListFragment_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventPanelListFragment_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "happenedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventType",
              "kind": "LinkedField",
              "name": "type",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventCardFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventConnection",
  "abstractKey": null
};
})();

(node as any).hash = "21a4bed0108bde1e1004a78e94b13ecd";

export default node;
